import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_marketing-economy/artifacts/q6npai4a_907F1F75-F4C3-4C66-925B-49CBEC490807.PNG";

const TermsOfService = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      title: "Conditions d'utilisation",
      lastUpdated: "Dernière mise à jour : Décembre 2025",
      backToHome: "Retour à l'accueil",
      sections: [
        {
          title: "1. Acceptation des conditions",
          content: `En accédant à la plateforme AQERA ou en l'utilisant, vous acceptez d'être lié par les présentes conditions d'utilisation (« Conditions »). Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser notre plateforme.

Ces Conditions constituent un contrat légal entre vous et AQERA Inc., une société constituée en vertu des lois du Québec, Canada (« AQERA », « nous », « notre » ou « nos »).`
        },
        {
          title: "2. Description des services",
          content: `AQERA est une plateforme de marketing à la performance qui permet :

**Pour les utilisateurs :**
• De découvrir et compléter des missions marketing rémunérées
• D'accumuler des récompenses en argent dans un portefeuille numérique
• D'utiliser ces récompenses dans un marketplace de cartes-cadeaux partenaires

**Pour les commerces partenaires :**
• De créer des missions marketing ciblées
• De définir et gérer des budgets marketing
• D'accéder à des statistiques de performance en temps réel`
        },
        {
          title: "3. Inscription et compte",
          content: `**3.1 Admissibilité**
Pour utiliser AQERA, vous devez :
• Avoir au moins 18 ans ou l'âge de la majorité dans votre province de résidence
• Résider au Canada
• Fournir des informations exactes et complètes lors de l'inscription

**3.2 Responsabilité du compte**
Vous êtes responsable de :
• Maintenir la confidentialité de vos identifiants de connexion
• Toutes les activités effectuées sous votre compte
• Nous informer immédiatement de toute utilisation non autorisée

**3.3 Un compte par personne**
Chaque utilisateur ne peut détenir qu'un seul compte. La création de comptes multiples peut entraîner la suspension ou la résiliation de tous vos comptes.`
        },
        {
          title: "4. Missions et récompenses",
          content: `**4.1 Nature des missions**
Les missions sont des actions marketing définies par nos commerces partenaires. Chaque mission précise :
• Les actions requises
• Les critères de validation
• Le montant de la récompense
• La durée de disponibilité

**4.2 Validation des missions**
AQERA se réserve le droit de :
• Vérifier la complétion légitime des missions
• Rejeter les missions complétées de manière frauduleuse
• Suspendre les comptes suspectés de fraude

**4.3 Récompenses**
• Les récompenses sont créditées après validation de la mission
• Les montants sont en dollars canadiens (CAD)
• AQERA peut modifier les montants des récompenses à tout moment
• Les récompenses ne sont pas transférables et n'ont aucune valeur monétaire jusqu'à leur utilisation dans le marketplace`
        },
        {
          title: "5. Portefeuille numérique (Wallet)",
          content: `**5.1 Solde du portefeuille**
• Votre solde représente les récompenses accumulées
• Le solde ne porte pas d'intérêts
• AQERA n'est pas une institution financière

**5.2 Utilisation du solde**
Votre solde peut être utilisé exclusivement pour :
• Acheter des cartes-cadeaux dans le marketplace AQERA
• D'autres services que nous pourrions offrir à l'avenir

**5.3 Expiration**
Les soldes inactifs pendant une période de 24 mois peuvent expirer conformément aux lois applicables sur les biens non réclamés.`
        },
        {
          title: "6. Abonnement pour les commerces",
          content: `**6.1 Tarification**
L'abonnement pour les commerces partenaires est de 49 $ CAD par mois.

**6.2 Essai gratuit**
Nous offrons un essai gratuit de 7 jours pour les nouveaux commerces partenaires.

**6.3 Facturation**
• La facturation est mensuelle et récurrente
• Les frais sont facturés au début de chaque période de facturation
• Toutes les taxes applicables (TPS/TVQ) seront ajoutées

**6.4 Annulation**
Vous pouvez annuler votre abonnement à tout moment. L'annulation prendra effet à la fin de la période de facturation en cours. Aucun remboursement n'est accordé pour les périodes partielles.`
        },
        {
          title: "7. Conduite de l'utilisateur",
          content: `Vous vous engagez à ne pas :

• Créer plusieurs comptes ou utiliser de fausses identités
• Compléter des missions de manière frauduleuse
• Utiliser des bots, scripts ou outils automatisés
• Tenter de manipuler ou contourner nos systèmes
• Violer les droits de propriété intellectuelle
• Publier du contenu illégal, offensant ou diffamatoire
• Harceler d'autres utilisateurs ou notre personnel
• Utiliser la plateforme à des fins illégales

Le non-respect de ces règles peut entraîner la suspension ou la résiliation immédiate de votre compte, sans préavis ni compensation.`
        },
        {
          title: "8. Propriété intellectuelle",
          content: `**8.1 Droits d'AQERA**
Tous les droits de propriété intellectuelle relatifs à la plateforme AQERA, y compris les marques de commerce, logos, logiciels, designs et contenus, appartiennent à AQERA Inc. ou à ses concédants de licence.

**8.2 Licence limitée**
Nous vous accordons une licence limitée, non exclusive, non transférable et révocable pour utiliser notre plateforme conformément à ces Conditions.

**8.3 Contenu utilisateur**
En soumettant du contenu sur notre plateforme, vous nous accordez une licence mondiale, non exclusive et libre de redevances pour utiliser, reproduire et afficher ce contenu dans le cadre de nos services.`
        },
        {
          title: "9. Limitation de responsabilité",
          content: `**9.1 Services « tels quels »**
La plateforme AQERA est fournie « telle quelle » et « selon disponibilité », sans garantie d'aucune sorte, expresse ou implicite.

**9.2 Limitation des dommages**
Dans toute la mesure permise par la loi applicable, AQERA ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, y compris la perte de profits, de données ou d'opportunités commerciales.

**9.3 Plafond de responsabilité**
Notre responsabilité totale envers vous ne dépassera pas le montant que vous nous avez payé au cours des 12 mois précédant la réclamation, ou 100 $ CAD, selon le montant le plus élevé.`
        },
        {
          title: "10. Indemnisation",
          content: `Vous acceptez d'indemniser, de défendre et de dégager de toute responsabilité AQERA, ses dirigeants, administrateurs, employés et agents contre toute réclamation, dommage, perte, responsabilité et dépense (y compris les frais juridiques raisonnables) découlant de :

• Votre utilisation de la plateforme
• Votre violation de ces Conditions
• Votre violation des droits d'un tiers
• Votre contenu soumis sur la plateforme`
        },
        {
          title: "11. Résiliation",
          content: `**11.1 Par vous**
Vous pouvez fermer votre compte à tout moment en nous contactant ou via les paramètres de votre compte.

**11.2 Par AQERA**
Nous pouvons suspendre ou résilier votre compte à tout moment, avec ou sans motif, avec ou sans préavis.

**11.3 Effets de la résiliation**
À la résiliation :
• Vous perdez l'accès à votre compte et à la plateforme
• Tout solde non utilisé peut être confisqué en cas de violation des Conditions
• Les sections qui, de par leur nature, doivent survivre à la résiliation, resteront en vigueur`
        },
        {
          title: "12. Modifications des conditions",
          content: `Nous nous réservons le droit de modifier ces Conditions à tout moment. Les modifications prendront effet dès leur publication sur notre plateforme. Votre utilisation continue de la plateforme après la publication des modifications constitue votre acceptation des nouvelles Conditions.

Pour les modifications importantes, nous vous en informerons par courriel ou via une notification sur la plateforme.`
        },
        {
          title: "13. Droit applicable et juridiction",
          content: `Ces Conditions sont régies par les lois de la province de Québec et les lois fédérales du Canada qui s'y appliquent. Tout litige découlant de ces Conditions sera soumis à la compétence exclusive des tribunaux du district judiciaire de Montréal, Québec.

**Protection du consommateur**
Rien dans ces Conditions n'a pour effet de limiter les droits que vous pourriez avoir en vertu de la Loi sur la protection du consommateur du Québec ou d'autres lois impératives applicables.`
        },
        {
          title: "14. Dispositions générales",
          content: `**14.1 Intégralité de l'entente**
Ces Conditions, ainsi que notre Politique de confidentialité, constituent l'intégralité de l'entente entre vous et AQERA concernant l'utilisation de notre plateforme.

**14.2 Divisibilité**
Si une disposition de ces Conditions est jugée invalide ou inapplicable, les autres dispositions resteront pleinement en vigueur.

**14.3 Renonciation**
Le fait pour AQERA de ne pas exercer un droit prévu aux présentes ne constitue pas une renonciation à ce droit.

**14.4 Cession**
Vous ne pouvez pas céder vos droits ou obligations en vertu de ces Conditions sans notre consentement écrit préalable.`
        },
        {
          title: "15. Nous contacter",
          content: `Pour toute question concernant ces Conditions d'utilisation :

**AQERA Inc.**
Courriel : legal@aqera.app
Montréal, Québec, Canada

Pour les questions relatives à la protection des renseignements personnels, veuillez consulter notre Politique de confidentialité ou nous contacter à privacy@aqera.app.`
        }
      ]
    },
    en: {
      title: "Terms of Service",
      lastUpdated: "Last updated: December 2025",
      backToHome: "Back to home",
      sections: [
        {
          title: "1. Acceptance of Terms",
          content: `By accessing or using the AQERA platform, you agree to be bound by these terms of service ("Terms"). If you do not accept these Terms, please do not use our platform.

These Terms constitute a legal contract between you and AQERA Inc., a company incorporated under the laws of Quebec, Canada ("AQERA", "we", "our" or "us").`
        },
        {
          title: "2. Description of Services",
          content: `AQERA is a performance marketing platform that allows:

**For users:**
• To discover and complete paid marketing missions
• To accumulate cash rewards in a digital wallet
• To use these rewards in a marketplace of partner gift cards

**For partner businesses:**
• To create targeted marketing missions
• To define and manage marketing budgets
• To access real-time performance statistics`
        },
        {
          title: "3. Registration and Account",
          content: `**3.1 Eligibility**
To use AQERA, you must:
• Be at least 18 years old or the age of majority in your province of residence
• Reside in Canada
• Provide accurate and complete information upon registration

**3.2 Account Responsibility**
You are responsible for:
• Maintaining the confidentiality of your login credentials
• All activities performed under your account
• Notifying us immediately of any unauthorized use

**3.3 One Account Per Person**
Each user may only hold one account. Creating multiple accounts may result in the suspension or termination of all your accounts.`
        },
        {
          title: "4. Missions and Rewards",
          content: `**4.1 Nature of Missions**
Missions are marketing actions defined by our partner businesses. Each mission specifies:
• Required actions
• Validation criteria
• Reward amount
• Availability period

**4.2 Mission Validation**
AQERA reserves the right to:
• Verify legitimate completion of missions
• Reject missions completed fraudulently
• Suspend accounts suspected of fraud

**4.3 Rewards**
• Rewards are credited after mission validation
• Amounts are in Canadian dollars (CAD)
• AQERA may modify reward amounts at any time
• Rewards are non-transferable and have no monetary value until used in the marketplace`
        },
        {
          title: "5. Digital Wallet",
          content: `**5.1 Wallet Balance**
• Your balance represents accumulated rewards
• The balance does not earn interest
• AQERA is not a financial institution

**5.2 Use of Balance**
Your balance may be used exclusively to:
• Purchase gift cards in the AQERA marketplace
• Other services we may offer in the future

**5.3 Expiration**
Balances inactive for a period of 24 months may expire in accordance with applicable unclaimed property laws.`
        },
        {
          title: "6. Business Subscription",
          content: `**6.1 Pricing**
The subscription for partner businesses is $49 CAD per month.

**6.2 Free Trial**
We offer a 7-day free trial for new partner businesses.

**6.3 Billing**
• Billing is monthly and recurring
• Fees are charged at the beginning of each billing period
• All applicable taxes (GST/QST) will be added

**6.4 Cancellation**
You may cancel your subscription at any time. Cancellation will take effect at the end of the current billing period. No refunds are provided for partial periods.`
        },
        {
          title: "7. User Conduct",
          content: `You agree not to:

• Create multiple accounts or use false identities
• Complete missions fraudulently
• Use bots, scripts or automated tools
• Attempt to manipulate or circumvent our systems
• Violate intellectual property rights
• Post illegal, offensive or defamatory content
• Harass other users or our staff
• Use the platform for illegal purposes

Failure to comply with these rules may result in immediate suspension or termination of your account, without notice or compensation.`
        },
        {
          title: "8. Intellectual Property",
          content: `**8.1 AQERA's Rights**
All intellectual property rights relating to the AQERA platform, including trademarks, logos, software, designs and content, belong to AQERA Inc. or its licensors.

**8.2 Limited License**
We grant you a limited, non-exclusive, non-transferable and revocable license to use our platform in accordance with these Terms.

**8.3 User Content**
By submitting content on our platform, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce and display such content in connection with our services.`
        },
        {
          title: "9. Limitation of Liability",
          content: `**9.1 "As Is" Services**
The AQERA platform is provided "as is" and "as available", without warranty of any kind, express or implied.

**9.2 Limitation of Damages**
To the fullest extent permitted by applicable law, AQERA will not be liable for any indirect, incidental, special, consequential or punitive damages, including loss of profits, data or business opportunities.

**9.3 Liability Cap**
Our total liability to you will not exceed the amount you paid us in the 12 months preceding the claim, or $100 CAD, whichever is greater.`
        },
        {
          title: "10. Indemnification",
          content: `You agree to indemnify, defend and hold harmless AQERA, its officers, directors, employees and agents from any claims, damages, losses, liabilities and expenses (including reasonable legal fees) arising from:

• Your use of the platform
• Your violation of these Terms
• Your violation of any third party's rights
• Your content submitted on the platform`
        },
        {
          title: "11. Termination",
          content: `**11.1 By You**
You may close your account at any time by contacting us or through your account settings.

**11.2 By AQERA**
We may suspend or terminate your account at any time, with or without cause, with or without notice.

**11.3 Effects of Termination**
Upon termination:
• You lose access to your account and the platform
• Any unused balance may be forfeited in case of Terms violation
• Sections that by their nature should survive termination will remain in effect`
        },
        {
          title: "12. Changes to Terms",
          content: `We reserve the right to modify these Terms at any time. Changes will take effect upon posting on our platform. Your continued use of the platform after posting of changes constitutes your acceptance of the new Terms.

For significant changes, we will notify you by email or through a notification on the platform.`
        },
        {
          title: "13. Governing Law and Jurisdiction",
          content: `These Terms are governed by the laws of the Province of Quebec and the federal laws of Canada applicable therein. Any dispute arising from these Terms will be submitted to the exclusive jurisdiction of the courts of the judicial district of Montreal, Quebec.

**Consumer Protection**
Nothing in these Terms has the effect of limiting any rights you may have under Quebec's Consumer Protection Act or other applicable mandatory laws.`
        },
        {
          title: "14. General Provisions",
          content: `**14.1 Entire Agreement**
These Terms, together with our Privacy Policy, constitute the entire agreement between you and AQERA regarding the use of our platform.

**14.2 Severability**
If any provision of these Terms is found to be invalid or unenforceable, the other provisions will remain in full force and effect.

**14.3 Waiver**
AQERA's failure to exercise a right provided herein does not constitute a waiver of that right.

**14.4 Assignment**
You may not assign your rights or obligations under these Terms without our prior written consent.`
        },
        {
          title: "15. Contact Us",
          content: `For any questions about these Terms of Service:

**AQERA Inc.**
Email: legal@aqera.app
Montreal, Quebec, Canada

For questions regarding the protection of personal information, please see our Privacy Policy or contact us at privacy@aqera.app.`
        }
      ]
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-[#020408]">
      {/* Header */}
      <header className="border-b border-white/5">
        <div className="section-container py-6">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="AQERA" className="h-10 w-auto" />
            </a>
            <a 
              href="/" 
              className="flex items-center gap-2 text-[#94A3B8] hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              {t.backToHome}
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="section-container py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t.title}</h1>
          <p className="text-[#64748B] mb-12">{t.lastUpdated}</p>
          
          <div className="space-y-10">
            {t.sections.map((section, index) => (
              <section key={index} className="prose prose-invert max-w-none">
                <h2 className="text-xl font-semibold text-white mb-4">{section.title}</h2>
                <div className="text-[#94A3B8] leading-relaxed whitespace-pre-line">
                  {section.content.split('**').map((part, i) => 
                    i % 2 === 1 ? <strong key={i} className="text-white">{part}</strong> : part
                  )}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/5 py-8">
        <div className="section-container">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <img src={LOGO_URL} alt="AQERA" className="h-8 w-auto" />
            <p className="text-[#64748B] text-sm">© 2025 AQERA Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
